<template>
  <section class="modules-wrap">
    <!-- table start -->
    <el-table
      :data="tableData"
      height="100%"
      :border="true"
      :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
    >
      <el-table-column type="index" align="center" width="100" label="序号">
      </el-table-column>
      <el-table-column prop="buyer_name" align="center" label="业务员">
      </el-table-column>
      <el-table-column
        prop="number"
        align="center"
        label="出货件数（件）"
      ></el-table-column>
      <el-table-column prop="time" align="center" label="日期">
      </el-table-column>
      <el-table-column
        prop="buyer_category"
        min-width="150"
        show-overflow-tooltip
        align="center"
        label="所属品类"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.buyer_category || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="tonnage_num"
        align="center"
        label="出货重量（吨）"
      ></el-table-column>
      <el-table-column
        prop="total_amount"
        align="center"
        label="出货额（万元）"
      ></el-table-column>

      <!-- <el-table-column
        label="操作"
        min-width="150"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="onHandleEditData(scope.row)"
            >编辑</el-button
          >
          <el-button type="text" @click="onHandleDetail(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <!-- table end -->
  </section>
</template>

<script>
export default {
  name: "TableList",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    /**
     * 编辑
     */
    onHandleEditData(row) {},
    /**
     * 详情
     */
    onHandleDetail(row) {
      const query = {
        id: row.id,
      };
      this.$router.push({
        path: "/data-detail",
        query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modules-wrap {
  flex: 1;
  overflow: hidden;
  .table {
    height: calc(100% - 20px);
  }
}
</style>
